import { FETCH_SMS_SAFE_PROMOT, GET_EVENTS_MEETINGS, FETCH_DEFAULT_TILES } from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchSmsSafetyPromtions = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: 'promotions/',
    ...FETCH_SMS_SAFE_PROMOT
  }
});
export const getEventsMeetings = start => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/promotions/?date=${start}`,
    ...GET_EVENTS_MEETINGS
  }
});

export const fetchDefaultTiles = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/promotions/default_tiles/',
    ...FETCH_DEFAULT_TILES
  }
});
